import { render, staticRenderFns } from "./ProjectNav.vue?vue&type=template&id=717bf37e&lang=pug&"
import script from "./ProjectNav.vue?vue&type=script&lang=js&"
export * from "./ProjectNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports